__webpack_require__.p = "/vanilla-assets/javascript/";